<template>
    <div class="container mt-3">

        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div class="alert alert-success" v-if="alertMessage">{{ alertMessage }}</div>
                        <form @submit.prevent="updateMerchant">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>ID</label>
                                        <input type="text" class="form-control" v-model="merchant.id" readonly disabled>
                                    </div>
                                    <div class="form-group">
                                        <label>Наименование компании</label>
                                        <input type="text" class="form-control" aria-describedby="emailHelp" placeholder="Введите наименование магазина" v-model="merchant.name">
                                        <small class="form-text text-muted">Данное название отображается на платежной странице.</small>
                                    </div>

                                    <div class="form-group">
                                        <label>Контактный номер телефона</label>
                                        <input type="text" class="form-control" placeholder="Введите контактный номер телефона" v-model="merchant.contacts">
                                    </div>

                                    <div class="form-group">
                                        <label>Email</label>
                                        <input type="email" class="form-control" placeholder="Введите email" v-model="merchant.email">
                                        <small class="form-text text-muted">Email будет получать отчеты.</small>
                                    </div>

                                    <div class="form-group">
                                        <label>Длительность жизни ссылки</label>
                                        <input type="text" class="form-control"  v-model="merchant.timeout_minutes">
                                        <small class="form-text text-muted">1 день = 1440 мин. 2 день = 2880 мин. Макс = 4300 мин.</small>
                                        <small v-if="merchant.timeout_minutes > 4300" style="color: red;">Максимальное количество 4300.</small>
                                    </div>
                                </div>

                                <div class="col-md-5 offset-md-1">

                                    <img :v-show="merchant.logo" v-if="merchant.logo" :src="logoUrl"  width="200" >
                                    <div class="form-group">
                                        <label>Логотип</label>
                                        <input type="file" class="form-control-file" ref="file">
                                        <small class="form-text text-muted">Логотип для отображения на платежной странице. Ширина изображения 200px.</small>
                                    </div>

                                </div>

                                <div class="col-md-12">
                                    <button class="btn btn-primary mr-2" :disabled="!formValid">Сохранить</button>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
    import {mapState} from 'vuex'
    export default {
        name: "SettingsMain",
        computed: {
            ...mapState({
                merchant: state => state.merchant,
                loading: state => state.loading
            }),
            formValid () {
                return this.merchant.name
                    && this.merchant.contacts
                    && this.merchant.email
                    && this.merchant.name.length > 0
                    && this.merchant.contacts.length > 0
                    && this.merchant.email.length > 0
                    && this.loading === 0
                    && this.merchant.timeout_minutes < 4300
            }
        },
        data () {
            return {
                alertMessage: '',
                logoUrl: ''
            }
        },
        created() {
            this.getMerchant();
        },
        methods: {
            getMerchant() {
                this.$store.commit('setLoading', 1);
                axios.get('/admin/merchant')
                    .then(response => {
                        response = response.data;
                        if (response.data !== null) {
                            this.$store.commit('setMerchant', response.data);
                            this.logoUrl = '/storage/' + this.merchant.logo;
                        }
                        this.$store.commit('unsetLoading')
                    });
            },
            updateMerchant() {
                this.$store.commit('setLoading', 1);
                let file = this.$refs.file.files[0];
                if (file) {
                    this.logoUrl = URL.createObjectURL(file);
                }
                let formData = new FormData();
                if (file) {
                    formData.append('file', file);
                }
                formData.append('name', this.merchant.name);
                formData.append('contacts', this.merchant.contacts);
                formData.append('email', this.merchant.email);
                formData.append('timeout-minutes', this.merchant.timeout_minutes);
                axios.post('/admin/merchant/update', formData, {headers: {'Content-Type': 'multipart/form-data'}})
                    .then((response) => {
                        this.alertMessage = response.data.message
                    }).catch(response => {

                }).then(response => {
                    this.$store.commit('unsetLoading');
                });
            }
        }
    }
</script>

<style scoped>

</style>
